import { ModalWrapper } from 'src/components/ModalWrapper';
import { ShopModalContainer } from './components/ShopModalContainer';

import { useTranslation } from 'react-i18next';
import { Button } from 'src/components/Buttons/Button';
import { useModalContext } from 'src/hooks/useModalContext';
import { ModalProps } from './types';
import { FreespinsPurchaseBlock } from 'src/pages/Shop/AuthorizedShop/components/FreespinsPurchaseBlock';

export const NoCoinsForFreespinsModal = () => {
  const { closeModal, openModal, modalProps } = useModalContext<ModalProps>();
  const { t } = useTranslation();
  const handleToHowToEarn = () => {
    closeModal();
    const freespinsInGames = document.getElementById('howToEarn');
    freespinsInGames?.scrollIntoView({
      behavior: 'smooth'
    });
  };

  return (
    <ModalWrapper showCross={false} isTransparentBg>
      <ShopModalContainer title="shop.noCoins" text="bonusPage.youDont">
        <div className="flex flex-col mb-[50px]">
          <FreespinsPurchaseBlock item={modalProps?.item} />
          <Button
            className="w-[165px] self-center"
            onClick={() => {
              closeModal();
              openModal('DEPOSIT');
            }}>
            {t('freeSpins.deposit')}
          </Button>
          <p
            className="text-base underline text-center pt-5 text-sp_title font-bold cursor-pointer"
            onClick={handleToHowToEarn}>
            {t('bonusPage.howToEarn')}
          </p>
        </div>
      </ShopModalContainer>
    </ModalWrapper>
  );
};
